import React, { Component } from "react";

import { Icon } from "@culturehq/components";
import { t } from "app/utils";

class RatingItem extends Component {
  static defaultProps = {
    onChange: () => {},
    submittedResponse: {}
  };

  constructor(props) {
    super(props);

    this.state = { body: props.submittedResponse.body };
  }

  handleChange = body => {
    const { onChange, surveyItem } = this.props;

    this.setState({ body });
    onChange({ surveyItemId: surveyItem.id, body });
  };

  render() {
    const { body } = this.state;

    return (
      <div className="SurveyItemRating">
        <div className="options clearfix">
          {[1, 2, 3, 4, 5].map(optionValue => (
            <div
              key={optionValue}
              className={`star ${body >= optionValue ? "active" : "inactive"}`}
              onClick={() => this.handleChange(optionValue)}
              role="button"
              tabIndex={0}
              aria-label={t(`${optionValue} star${optionValue === 1 ? "" : "s"}`)}
            >
              <Icon icon="star" />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default RatingItem;
